<app-modal-shell
  [isOpen]="vm.instrumentoFormularioAberto"
  [title]="vm.instrumentoFormularioTitulo"
  [panelClass]="'instrumento-modal-panel w-[94vw] max-w-[30rem] sm:max-h-[calc(100dvh-2rem)]'"
  [bodyClass]="'flex min-h-0 flex-col p-0'"
  [bodyScrollable]="false"
  [closeOnBackdropClick]="false"
  (fechado)="vm.fecharFormularioInstrumento()">
  <div *ngIf="vm.instrumentoCarregando" class="py-8 text-center text-sm text-gray-500 dark:text-gray-400">
    Carregando formulário do instrumento...
  </div>

  <form *ngIf="!vm.instrumentoCarregando" class="flex min-h-0 flex-1 flex-col" (submit)="$event.preventDefault(); vm.salvarInstrumento()">
    <app-tabs class="block flex-1 min-h-0 overflow-hidden" [activeTab]="vm.instrumentoAbaAtiva" (activeTabChange)="vm.onInstrumentoAbaChange($event)">
      <app-tab-panel tabId="informacoes" label="Informações gerais">
        <div class="instrumento-modal-content space-y-3 p-4 mb-1 ">
          <app-prototype-select
            label="Turma"
            placeholder="Selecione a turma"
            [required]="true"
            [value]="vm.instrumentoForm.turmaId"
            [disabled]="vm.instrumentoTurmaBloqueadaContexto"
            [clearable]="!vm.instrumentoTurmaBloqueadaContexto"
            [options]="vm.instrumentoTurmaOptions"
            (valueChange)="vm.onInstrumentoTurmaSelectChange($event)">
          </app-prototype-select>

          <app-prototype-select
            class="mb-1"
            [label]="vm.instrumentoLabelItemEducacional"
            [placeholder]="vm.instrumentoTurmaEAtividade ? 'Selecione a atividade' : 'Selecione o componente curricular'"
            [required]="true"
            [value]="vm.instrumentoForm.itemEducacionalId"
            [disabled]="!vm.instrumentoForm.turmaId"
            [options]="vm.instrumentoItemEducacionalOptions"
            (valueChange)="vm.onInstrumentoItemEducacionalSelectChange($event)">
          </app-prototype-select>

          <div *ngIf="vm.shouldShowInstrumentoPeriodoField">
            <span class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Período avaliativo<span class="text-red-500">*</span></span>
            <app-periodo-select
              [options]="vm.instrumentoPeriodoOptions"
              [selectedId]="vm.instrumentoForm.periodoAvaliativoId"
              [disabled]="!vm.instrumentoForm.itemEducacionalId"
              [clearable]="true"
              [emptyLabel]="'Selecione o período avaliativo'"
              [dropdownWidthClass]="'w-full'"
              (selectedIdChange)="vm.onInstrumentoPeriodoSelectChange($event)">
            </app-periodo-select>
          </div>

          <div *ngIf="vm.instrumentoTurmaEjaModular || vm.instrumentoPeriodoEncerradoSelecionado" class="rounded-xl border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/20 p-3 text-sm text-amber-900 dark:text-amber-200">
            <p *ngIf="vm.instrumentoTurmaEjaModular">Não é permitido cadastrar instrumentos para turmas de EJA modular.</p>
            <p *ngIf="vm.instrumentoPeriodoEncerradoSelecionado">O período avaliativo selecionado está encerrado.</p>
            <p *ngIf="vm.instrumentoEdicaoSomenteDataPermitida">Com o período encerrado, apenas a data pode ser alterada e o instrumento deve permanecer no mesmo período avaliativo.</p>
          </div>

          <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
            <label class="block">
              <span class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Data<span class="text-red-500">*</span></span>
              <app-datepicker
                [dataSelecionada]="vm.instrumentoDataSelecionada"
                fieldClass="instrumento-modal-material-field w-full"
                dateConstraintMode="all"
                placeholder="Selecione a data"
                (dateChange)="vm.onInstrumentoDataChange($event)">
              </app-datepicker>
            </label>

            <app-prototype-select
              class="mb-1"
              label="Tipo de instrumento"
              placeholder="Selecione o tipo de instrumento"
              [required]="true"
              [value]="vm.instrumentoForm.tipoInstrumento"
              [options]="vm.instrumentoTipoOptions"
              (valueChange)="vm.onInstrumentoTipoSelectChange($event)">
            </app-prototype-select>
          </div>

          <app-prototype-select
            *ngIf="vm.instrumentoForm.tipoInstrumento === 'RECUPERACAO_PARALELA'"
            label="Instrumento de avaliação a ser recuperado"
            placeholder="Selecione o instrumento"
            [required]="true"
            [value]="vm.instrumentoForm.instrumentoRecuperacaoId"
            [disabled]="!vm.instrumentosRecuperacaoOptions.length"
            [options]="vm.instrumentoRecuperacaoSelectOptions"
            (valueChange)="vm.onInstrumentoRecuperacaoSelectChange($event)">
          </app-prototype-select>

          <div>
            <div class="mb-1 flex items-center justify-between gap-2">
              <span class="block text-xs font-medium text-gray-700 dark:text-gray-300">Descrição/Título<span class="text-red-500">*</span></span>
              <div *ngIf="vm.instrumentoDescricoesRecentes.length" class="relative group">
                <button type="button" class="text-xs font-medium text-blue-600 dark:text-blue-300">Descrições recentes</button>
                <div class="absolute right-0 top-full z-20 mt-2 hidden w-64 rounded-xl border border-gray-200 bg-white p-2 shadow-xl group-hover:block dark:border-gray-700 dark:bg-gray-800">
                  <button type="button" *ngFor="let item of vm.instrumentoDescricoesRecentes" (click)="vm.selecionarDescricaoRecenteInstrumento(item.descricao)" class="block w-full rounded-lg px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-gray-700">{{ item.descricao }}</button>
                </div>
              </div>
            </div>
            <input type="text" [(ngModel)]="vm.instrumentoForm.descricao" maxlength="100" name="instrumentoDescricao" class="w-full rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-900 dark:text-gray-100">
          </div>

          <label class="block">
            <span class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Sigla<span class="text-red-500">*</span></span>
            <input type="text" [(ngModel)]="vm.instrumentoForm.sigla" maxlength="5" name="instrumentoSigla" class="w-full rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-900 dark:text-gray-100">
          </label>

          <label class="block">
            <span class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Conteúdo</span>
            <textarea [(ngModel)]="vm.instrumentoForm.conteudo" maxlength="4000" rows="2" name="instrumentoConteudo" class="w-full rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-900 dark:text-gray-100"></textarea>
          </label>

          <label class="block">
            <span class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Critério avaliativo</span>
            <textarea [(ngModel)]="vm.instrumentoForm.criteriosAvaliativos" maxlength="4000" rows="2" name="instrumentoCriterios" class="w-full rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-900 dark:text-gray-100"></textarea>
          </label>


          <div *ngIf="vm.instrumentoExibeFaixaNotas || vm.instrumentoExibePeso" class="grid grid-cols-1 gap-3 sm:grid-cols-3">
            <label *ngIf="vm.instrumentoExibeFaixaNotas" class="block">
              <span class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Menor nota</span>
              <input #notaMinimaInput type="text" inputmode="decimal" pattern="[0-9]{0,2}[.,]?[0-9]*" maxlength="2" autocomplete="off" [(ngModel)]="vm.instrumentoForm.notaMinima" (ngModelChange)="vm.onInstrumentoCampoNumericoChange('notaMinima', $event)" (blur)="vm.onInstrumentoCampoNumericoBlur('notaMinima')" (keydown)="vm.onInstrumentoCampoNumericoKeyDown($event)" name="instrumentoNotaMinima" class="w-full rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-900 dark:text-gray-100" [disabled]="vm.instrumentoForm.tipoInstrumento === 'RECUPERACAO_PARALELA'">
            </label>

            <label *ngIf="vm.instrumentoExibeFaixaNotas" class="block">
              <span class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Maior nota</span>
              <input #notaMaximaInput type="text" inputmode="decimal" pattern="[0-9]{0,2}[.,]?[0-9]*" maxlength="2" autocomplete="off" [(ngModel)]="vm.instrumentoForm.notaMaxima" (ngModelChange)="vm.onInstrumentoCampoNumericoChange('notaMaxima', $event)" (blur)="vm.onInstrumentoCampoNumericoBlur('notaMaxima')" (keydown)="vm.onInstrumentoCampoNumericoKeyDown($event)" name="instrumentoNotaMaxima" class="w-full rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-900 dark:text-gray-100" [disabled]="vm.instrumentoForm.tipoInstrumento === 'RECUPERACAO_PARALELA'">
            </label>

            <label *ngIf="vm.instrumentoExibePeso" class="block">
              <span class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Peso</span>
              <input #pesoInput type="text" inputmode="decimal" pattern="[0-9]*[.,]?[0-9]*" maxlength="3" autocomplete="off" [(ngModel)]="vm.instrumentoForm.peso" (ngModelChange)="vm.onInstrumentoCampoNumericoChange('peso', $event)" (blur)="vm.onInstrumentoCampoNumericoBlur('peso')" (keydown)="vm.onInstrumentoCampoNumericoKeyDown($event)" name="instrumentoPeso" class="w-full rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-900 dark:text-gray-100">
            </label>
          </div>
        </div>
      </app-tab-panel>

      <app-tab-panel tabId="anexos" label="Anexos">
        <div class="instrumento-modal-content p-4">
          <app-anexos
            [anexos]="vm.instrumentoAnexosItems"
            [uploading]="vm.instrumentoAnexosEnviando"
            [multiple]="true"
            [extensoesAceitas]="vm.instrumentoAnexosAccept"
            [extensoesLabel]="vm.instrumentoAnexosLabel"
            [tamanhoMaximoMb]="vm.instrumentoAnexosTamanhoMaximoMb"
            (fileSelected)="vm.onInstrumentoArquivoSelecionado($event)"
            (filesSelected)="vm.onInstrumentoArquivosSelecionados($event)"
            (remove)="vm.removerInstrumentoAnexoCompartilhado($event)"
            (download)="vm.baixarInstrumentoAnexoCompartilhado($event)">
          </app-anexos>
        </div>
      </app-tab-panel>

      <app-tab-panel tabId="dadosAdicionais" label="Dados adicionais">
        <div class="instrumento-modal-content p-4">
          <div *ngIf="vm.instrumentoCamposAdicionaisCarregando" class="text-sm text-gray-500 dark:text-gray-400">
            Carregando dados adicionais...
          </div>

          <div *ngIf="!vm.instrumentoCamposAdicionaisCarregando && !vm.instrumentoCampoAdicionalTemConteudo" class="rounded-xl border border-dashed border-gray-300 dark:border-gray-600 p-4 text-sm text-gray-500 dark:text-gray-400">
            Não há dados adicionais para este instrumento.
          </div>

          <app-cpa-grid-bridge
            *ngIf="!vm.instrumentoCamposAdicionaisCarregando && vm.instrumentoCampoAdicionalTemConteudo"
            [config]="vm.instrumentoCampoAdicional"
            (requiredFieldsValidChange)="vm.onInstrumentoCamposAdicionaisValidChange($event)">
          </app-cpa-grid-bridge>
        </div>
      </app-tab-panel>
    </app-tabs>

    <app-form-footer
      [salvando]="vm.instrumentoSalvando"
      [podeSubmeter]="vm.instrumentoFormularioValido"
      [labelSalvar]="'SALVAR'"
      [labelSalvando]="'SALVANDO...'"
      [mostrarExcluir]="!!vm.instrumentoForm.id"
      (cancelar)="vm.fecharFormularioInstrumento()"
      (excluir)="vm.confirmarExclusaoInstrumentoEmEdicao()"
      (salvar)="vm.salvarInstrumento()">
    </app-form-footer>
  </form>
</app-modal-shell>

<app-instrumento-exclusao-confirmacao-modal
  *ngIf="vm.instrumentoConfirmacao.aberta && vm.instrumentoConfirmacao.tipo === 'excluir'"
  [aberta]="vm.instrumentoConfirmacao.aberta"
  [instrumento]="vm.instrumentoConfirmacao.instrumento || null"
  [confirmadoExclusao]="vm.instrumentoConfirmacao.confirmadoExclusao ?? false"
  (confirmadoExclusaoChange)="vm.instrumentoConfirmacao.confirmadoExclusao = $event"
  (confirmar)="vm.confirmarAcaoInstrumento()"
  (cancelar)="vm.fecharConfirmacaoInstrumento()">
</app-instrumento-exclusao-confirmacao-modal>

<app-confirmacao-sim-nao
  [aberta]="vm.instrumentoConfirmacao.aberta && vm.instrumentoConfirmacao.tipo !== 'excluir'"
  [titulo]="vm.instrumentoConfirmacao.titulo"
  (confirmar)="vm.confirmarAcaoInstrumento()"
  (cancelar)="vm.fecharConfirmacaoInstrumento()">
  <ng-container *ngIf="vm.instrumentoConfirmacao.publicar">
    Deseja publicar o resultado e o parecer já registrados no instrumento
    <strong class="font-medium">{{ vm.instrumentoConfirmacao.instrumento?.sigla }} - {{ vm.instrumentoConfirmacao.instrumento?.descricao }}</strong>
    para Pais e Alunos?
  </ng-container>
  <ng-container *ngIf="!vm.instrumentoConfirmacao.publicar && vm.instrumentoConfirmacao.instrumento?.dataPublicacao">
    Os desempenhos já publicados no instrumento
    <strong class="font-medium">{{ vm.instrumentoConfirmacao.instrumento?.sigla }} - {{ vm.instrumentoConfirmacao.instrumento?.descricao }}</strong>
    foram publicados em
    <strong class="font-medium">{{ vm.formatarDataHoraPublicacao(vm.instrumentoConfirmacao.instrumento?.dataPublicacao || '') }}</strong>.<br>
    Deseja desfazer a publicação?
  </ng-container>
  <ng-container *ngIf="!vm.instrumentoConfirmacao.publicar && !vm.instrumentoConfirmacao.instrumento?.dataPublicacao">
    Os desempenhos já publicados no instrumento
    <strong class="font-medium">{{ vm.instrumentoConfirmacao.instrumento?.sigla }} - {{ vm.instrumentoConfirmacao.instrumento?.descricao }}</strong>
    serão despublicados.<br>
    Deseja desfazer a publicação?
  </ng-container>
</app-confirmacao-sim-nao>

<div *ngIf="vm.instrumentoRecuperacaoVinculada.aberta" class="fixed inset-0 bg-black/40 backdrop-blur-sm z-[90] flex items-center justify-center px-2 py-2 sm:px-4 sm:py-4">
  <div class="w-full max-w-[32rem] max-h-[calc(100vh-1rem)] overflow-y-auto rounded-md border border-[#d7dde7] bg-white dark:bg-gray-800 shadow-[0_20px_48px_rgba(15,23,42,0.22)] p-4">
    <div class="mb-4 flex items-start justify-between gap-3">
      <div>
        <h2 class="text-base font-semibold text-gray-900 dark:text-gray-100">Recuperação paralela vinculada</h2>
        <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">O período da recuperação paralela será ajustado para o mesmo período do instrumento recuperado. Revise os dados antes de confirmar.</p>
      </div>

      <button type="button" (click)="vm.fecharRecuperacaoVinculada()" class="h-8 w-8 inline-flex items-center justify-center rounded-md text-gray-500 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700" [disabled]="vm.instrumentoRecuperacaoVinculada.salvando">
        <lucide-icon name="x" class="w-4 h-4"></lucide-icon>
      </button>
    </div>

    <div class="rounded-xl border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/20 p-3 text-sm text-amber-900 dark:text-amber-200 mb-3">
      Ao confirmar, o instrumento recuperado e sua recuperação paralela serão atualizados de forma consistente.
    </div>

    <form *ngIf="vm.instrumentoRecuperacaoVinculada.instrumentoRecuperacao as recuperacao" class="space-y-3" (submit)="$event.preventDefault(); vm.confirmarRecuperacaoVinculada()">
      <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <label class="block sm:col-span-2">
          <span class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Descrição<span class="text-red-500">*</span></span>
          <input type="text" [(ngModel)]="recuperacao.descricao" maxlength="100" name="recuperacaoVinculadaDescricao" class="w-full rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-900 dark:text-gray-100">
        </label>

        <label class="block">
          <span class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Sigla<span class="text-red-500">*</span></span>
          <input type="text" [(ngModel)]="recuperacao.sigla" maxlength="5" name="recuperacaoVinculadaSigla" class="w-full rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-900 dark:text-gray-100">
        </label>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <label *ngIf="!vm.instrumentoTurmaEAtividade" class="block">
          <span class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Período avaliativo</span>
          <input type="text" [ngModel]="vm.instrumentoDescricaoPeriodo" name="recuperacaoVinculadaPeriodo" readonly class="w-full rounded border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 px-3 py-2 text-sm text-gray-600 dark:text-gray-300">
        </label>

        <label class="block">
          <span class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">Data<span class="text-red-500">*</span></span>
          <input type="date" [(ngModel)]="recuperacao.data" name="recuperacaoVinculadaData" class="instrumento-date-input w-full rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-900 dark:text-gray-100">
        </label>
      </div>

      <div *ngIf="vm.instrumentoRecuperacaoVinculadaErros.length" class="rounded-xl border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/20 p-3 text-sm text-amber-900 dark:text-amber-200">
        <p class="font-semibold mb-1">Revise as informações da recuperação paralela:</p>
        <ul class="list-disc pl-5 space-y-1">
          <li *ngFor="let erro of vm.instrumentoRecuperacaoVinculadaErros">{{ erro }}</li>
        </ul>
      </div>

      <div class="mt-5 flex flex-col-reverse sm:flex-row sm:justify-end gap-2">
        <button type="submit" class="rounded-md bg-[#4b5bdc] hover:bg-[#4252cf] px-4 py-2.5 text-sm font-medium text-white inline-flex items-center justify-center gap-2" [disabled]="vm.instrumentoRecuperacaoVinculada.salvando">
          <lucide-icon *ngIf="vm.instrumentoRecuperacaoVinculada.salvando" name="loader-2" class="w-4 h-4 animate-spin"></lucide-icon>
          <span>Salvar</span>
        </button>
        <button type="button" (click)="vm.fecharRecuperacaoVinculada()" class="rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 px-4 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-200" [disabled]="vm.instrumentoRecuperacaoVinculada.salvando">Cancelar</button>
      </div>
    </form>
  </div>
</div>
